import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './configureStore';
import { I18nextProvider } from 'react-i18next';
import i18next from './i18next/i18next';
import App from './App';
import { configAxios } from './Modules/core';
import registerServiceWorker from './registerServiceWorker';


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
const persistor = persistStore(store, null);
configAxios(store);
const rootElement = document.getElementById('root');
ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <I18nextProvider i18n={i18next}>
                <ConnectedRouter history={history}>
                    <App />
                </ConnectedRouter>
            </I18nextProvider>
        </PersistGate>
    </Provider>,
    rootElement);

registerServiceWorker();
